import { OnboardingApiClient } from '@fourthwall/services/dist/OnboardingApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useChecklistVisibilityMutation = createMutationHook(
  OnboardingApiClient.setChecklistVisibility,
  {
    mutationKey: ['checklistVisibility'],
  },
)
